import React from 'react';
import { Table } from '@wix/design-system';
import { TableTestkit } from '@wix/design-system/dist/testkit';
import { render, fireEvent } from '@testing-library/react';
import { TableDragAndDrop } from '../drag-and-drop';
import { move } from '../test-utils';
import { UniDriver } from '@wix/unidriver-core';

const TestApp = ({
  showSelection = false,
}: { showSelection?: boolean } = {}) => {
  const [items, setItems] = React.useState(() => [
    {
      id: '5880f692-4468-40cf-b5b5-07a0f535506a',
      name: 'Ice Cream',
      price: '$2.00',
    },
    {
      id: '60b73a3b-0252-4426-9bef-ac8a20a09492',
      name: 'Sandwich',
      price: '$5.00',
    },
    {
      id: '58319273-f5cc-4920-88fa-85b228763c95',
      name: 'Mushroom Pasta',
      price: '$7.00',
    },
  ]);

  return (
    <Table
      dataHook="table"
      columns={[
        { title: 'Name', render: (row) => row.name },
        { title: 'Price', render: (row) => row.price },
      ]}
      data={items}
      dragAndDrop={TableDragAndDrop}
      onDragEnd={({ active, over }) => {
        const newItems = move(items, active.id, over?.id);
        if (newItems) {
          setItems(newItems);
        }
      }}
      showSelection={showSelection}
    />
  );
};

const dragStart = async (node: UniDriver<any>) => {
  fireEvent.pointerDown(await node.getNative());
};

const dragEnd = async (node: UniDriver<any>) => {
  fireEvent.pointerUp(await node.getNative());
};

describe('Table DragAndDrop', () => {
  it('should reorder rows', async () => {
    const result = render(<TestApp />);
    const table = TableTestkit({
      wrapper: result.baseElement,
      dataHook: 'table',
    });

    expect((await table.getRowText(0))[1]).toBe('Ice Cream');
    expect((await table.getRowText(1))[1]).toBe('Sandwich');
    expect((await table.getRowText(2))[1]).toBe('Mushroom Pasta');

    await dragStart(table.getRow(0));
    await dragEnd(table.getRow(2));

    expect((await table.getRowText(0))[1]).toBe('Sandwich');
    expect((await table.getRowText(1))[1]).toBe('Mushroom Pasta');
    expect((await table.getRowText(2))[1]).toBe('Ice Cream');
  });

  it('should be able to click on selectAll with enabled DragAndDrop', async () => {
    const result = render(<TestApp showSelection />);
    const table = TableTestkit({
      wrapper: result.baseElement,
      dataHook: 'table',
    });

    expect(await table.exists()).toBe(true);

    const selectAll = await table.getBulkSelectionCheckboxDriver();
    await selectAll.click();

    expect(await table.isRowSelected(0)).toBe(true);
    expect(await table.isRowSelected(1)).toBe(true);
  });
});
